import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = {
  key: 1,
  class: "row fw-bold text-center"
}
const _hoisted_3 = {
  class: "verification-section",
  style: {"margin":"2px 0","padding":"8px","border":"2px solid #28a745","border-radius":"10px","background-color":"#f8f9fa"}
}
const _hoisted_4 = { class: "extract-buttons" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_15 = { class: "container border-1" }
const _hoisted_16 = { class: "border-1" }
const _hoisted_17 = { class: "border-1" }
const _hoisted_18 = { class: "border-1 text-center m-0 p-0" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["src", "onClick", "title"]
const _hoisted_21 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_22 = { class: "border-1 text-left" }
const _hoisted_23 = { class: "custom-file-input" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["type", "accept", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!$setup.loggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "h1 text-danger" }, " You first need to log into your account. ", -1)
        ]))]))
      : _createCommentVNode("", true),
    ($setup.loggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fw-bold h3" }, " Upload Documents... ", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "fw-bold" }, " (JPG, JPEG, PNG & GIF allowed with max 3MB size) ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "fw-bold h4 mb-3" }, "🔐 Use Facial Recognition From", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "extract-btn passport-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.extractFaceFromDocument('Passport'))),
                disabled: !$setup.getIconUrl('Passport') || $setup.isExtracting['Passport']
              }, [
                ($setup.isExtracting['Passport'])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "⏳"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, "📘")),
                _cache[4] || (_cache[4] = _createTextVNode(" Passport ", -1))
              ], 8, _hoisted_5),
              _createElementVNode("button", {
                class: "extract-btn photo-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.extractFaceFromDocument('Photo'))),
                disabled: !$setup.getIconUrl('Photo') || $setup.isExtracting['Photo']
              }, [
                ($setup.isExtracting['Photo'])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "⏳"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "📷")),
                _cache[5] || (_cache[5] = _createTextVNode(" Photo ", -1))
              ], 8, _hoisted_8),
              _createElementVNode("button", {
                class: "extract-btn sia-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.extractFaceFromDocument('SIABadge'))),
                disabled: !$setup.getIconUrl('SIABadge') || $setup.isExtracting['SIABadge']
              }, [
                ($setup.isExtracting['SIABadge'])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "⏳"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, "🪪")),
                _cache[6] || (_cache[6] = _createTextVNode(" SIA Badge ", -1))
              ], 8, _hoisted_11)
            ]),
            ($setup.faceStatusMessage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass($setup.faceStatusClass),
                  style: {"padding":"8px","border-radius":"4px","margin-top":"10px"}
                }, _toDisplayString($setup.faceStatusMessage), 3))
              : _createCommentVNode("", true),
            ($setup.savedFeatures)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("div", { class: "text-success" }, "✅ Face saved successfully for Recognition!", -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("table", _hoisted_15, [
            _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "border-1 bg-primary" }, [
                _createElementVNode("td", { class: "border-1 text-center" }, "Name"),
                _createElementVNode("td", { class: "border-1 text-center" }, "Uploaded"),
                _createElementVNode("td", { class: "border-1 text-left" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documentsConfig, (doc) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: doc.key,
                  class: "border-1"
                }, [
                  _createElementVNode("td", _hoisted_17, _toDisplayString(doc.displayName), 1),
                  _createElementVNode("td", _hoisted_18, [
                    ($setup.getIconUrl(doc.key))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("img", {
                            src: $setup.getIconUrl(doc.key),
                            style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                            onClick: ($event: any) => ($setup.downloadDocument(doc.key)),
                            title: 'Click to download ' + doc.displayName
                          }, null, 8, _hoisted_20)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, "NO"))
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", {
                        class: "custom-file-label",
                        onClick: ($event: any) => ($setup.triggerFileInput(doc.key))
                      }, " Upload " + _toDisplayString(doc.isPdf ? 'PDF' : 'Image'), 9, _hoisted_24),
                      _createElementVNode("input", {
                        type: doc.isPdf ? 'file' : 'file',
                        accept: doc.isPdf ? '.pdf' : 'image/*',
                        ref_for: true,
                        ref: el => $setup.setFileInputRef(doc.key, el),
                        style: {"display":"none"},
                        onChange: ($event: any) => (doc.isPdf ? $setup.handlePDFFileChange(doc.key, $event) : $setup.handleFileChange(doc.key, $event))
                      }, null, 40, _hoisted_25)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}